import { useTranslation } from 'react-i18next';

export default function AboutMap() {
  const { t } = useTranslation();

  const address = '3202+Lealand+Pl+Ln,+Lawrenceville,+GA+30044';
  const mapSrc = `https://maps.google.com/maps?q=${address}&output=embed`;

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-sky-50 text-sky-700 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest mb-4">
            {t('about_map_tag')}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">{t('about_map_title')}</h2>
          <p className="text-slate-500 text-base max-w-xl mx-auto">{t('about_map_desc')}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          {/* Contact info panel */}
          <div className="bg-[#0F2A50] rounded-2xl p-8 flex flex-col gap-7">
            {/* Address */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-sky-500/20 shrink-0 mt-0.5">
                <i className="ri-map-pin-2-line text-sky-400 text-lg"></i>
              </div>
              <div>
                <div className="text-sky-400 text-xs font-bold uppercase tracking-widest mb-1">{t('about_map_address_label')}</div>
                <div className="text-white text-sm leading-relaxed whitespace-pre-line">{t('about_map_address_val')}</div>
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-sky-500/20 shrink-0">
                <i className="ri-phone-line text-sky-400 text-lg"></i>
              </div>
              <div>
                <div className="text-sky-400 text-xs font-bold uppercase tracking-widest mb-1">{t('about_map_phone_label')}</div>
                <a
                  href="tel:+15615122820"
                  className="text-white hover:text-sky-300 text-sm transition-colors cursor-pointer"
                >
                  +1 (561) 512-2820
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-sky-500/20 shrink-0">
                <i className="ri-mail-line text-sky-400 text-lg"></i>
              </div>
              <div>
                <div className="text-sky-400 text-xs font-bold uppercase tracking-widest mb-1">{t('about_map_email_label')}</div>
                <a
                  href="mailto:info@orpminvestment.com"
                  className="text-white hover:text-sky-300 text-sm break-all transition-colors cursor-pointer"
                >
                  info@orpminvestment.com
                </a>
              </div>
            </div>

            {/* Hours */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-sky-500/20 shrink-0 mt-0.5">
                <i className="ri-time-line text-sky-400 text-lg"></i>
              </div>
              <div>
                <div className="text-sky-400 text-xs font-bold uppercase tracking-widest mb-1">{t('about_map_hours_label')}</div>
                <div className="text-white text-sm leading-relaxed whitespace-pre-line">{t('about_map_hours_val')}</div>
              </div>
            </div>

            {/* Directions button */}
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=3202+Lealand+Pl+Ln,+Lawrenceville,+GA+30044`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-sky-600 hover:bg-sky-500 text-white font-semibold text-sm px-5 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap mt-2"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-navigation-line text-base"></i>
              </div>
              {t('about_map_directions')}
            </a>
          </div>

          {/* Google Map embed */}
          <div className="lg:col-span-2 rounded-2xl overflow-hidden border border-slate-100 w-full h-[480px]">
            <iframe
              title="ORPM Investment LLC Location"
              src={mapSrc}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
